import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'

import Button from 'src/components/button'
import PageContainer from 'src/components/pageContainer'
import FormSteps from 'src/components/formSteps'
import SchedulingInfo from 'src/components/schedulingSteps/schedulingInfo'
import Alert from 'src/components/alert'
import WarningModal from 'src/components/warningModal'
import { Radio, Input, InputMask } from 'src/components/forms'

import withRootContext from 'context/withRootContextHOC'
import { useServiceScheduleContext } from 'src/context/serviceScheduleContext'
import { useLocationContext } from 'src/context/locationContext'

import { isMobile } from 'src/utils'

import { assetPrefix } from 'src/config/env_config'

import * as Ps from 'src/styles/pages/Scheduling'
import * as S from './styles'
import * as Gs from 'src/styles/global'

const MapMarquer = `${assetPrefix}/static/icons/map-marker-alt.svg`

function Location (props) {
  const { context } = props
  const router = useRouter()
  const [isEditingAddress, setIsEditingAddress] = useState(false)
  const [fetchedAddresses, setFetchedAddresses] = useState(false)
  const [keyboardOpen, setKeyboardOpen] = useState(false)

  const { userAddresses, firstName, getProfileAddresses } = context
  const { state: schedulingState, functions: schedulingFunctions } = useServiceScheduleContext()
  const { functions } = useLocationContext()

  const { modal } = schedulingState

  const {
    handleWarningModalClose
  } = schedulingFunctions

  const {
    cep,
    error,
    address,
    formList,
    storeName,
    activeStep,
    changeStore,
    scheduleBody,
    partnersData,
    totalPartners,
    isCustomAddress,
    customAddressType,
    selectedPetSchedule
  } = schedulingState

  const {
    handleEditCep,
    handleEditLocation,
    handleEditStoreName,
    handleSelectPartner,
    handleSetChangeStore,
    loadMorePartnersData,
    handleOpenCustomAddress,
    handleLocationInputData,
    handleSelectAnotherDayAndHour
  } = functions

  const selectedScheduleAvailable = !error.unavailabilityPets.some(
    (pet) => selectedPetSchedule && pet.id === selectedPetSchedule.id
  )

  useEffect(() => {
    const handleGetProfile = async () => {
      await getProfileAddresses()
      setFetchedAddresses(true)
    }
    if (userAddresses?.length > 0 && !scheduleBody.partner_id) {
      handleOpenCustomAddress('address', { context })
    } else if (userAddresses === undefined && firstName && !scheduleBody.partner_id) {
      handleGetProfile()
    }
  }, [])

  useEffect(() => {
    if (userAddresses?.length > 0 && fetchedAddresses) {
      handleOpenCustomAddress('address', { context })
    }
  }, [fetchedAddresses])

  useEffect(() => {
    if (customAddressType === 'address' && !isEditingAddress && !scheduleBody.partner_id) {
      handleLocationInputData({ context })
    }
  }, [customAddressType, address])

  const refreshStore = () => {
    handleSetChangeStore(true)
    handleOpenCustomAddress('address', { context })
  }

  const handlePressEnter = (event) => {
    if (event.key === 'Enter') {
      handleLocationInputData({ context })
    }
  }

  const handleInputFocus = () => {
    if (isMobile()) { setKeyboardOpen(true) }
  }

  const handleInputBlur = () => {
    if (isMobile()) { setKeyboardOpen(false) }
  }

  const showSchedulingInfo = () => {
    return (scheduleBody.pet_id !== undefined && activeStep > 1 && !keyboardOpen) || !!formList.length
  }

  const inputProps = {
    autoComplete: 'off'
  }

  return (
    <PageContainer isSchedulingSteps>
      <FormSteps context={context}>
        <S.AlignWrappers>
          <Gs.WrapperFormAndCard>
            <S.WrapperContainerAndTitle>
              <S.WrapperTitle>
                {!formList.length || changeStore ? (
                  <span>Selecione a loja de atendimento</span>
                ) : (
                  <span>Agende para o mesmo dia e horário escolhido para:</span>
                )}
              </S.WrapperTitle>

              {isMobile() && error.unavailabilityPets?.map((pet, i) => {
                return (
                  <S.Warning key={i}>
                    <img src={assetPrefix + '/static/icons/info-circle.svg'} />
                    Não temos profissionais disponíveis para o mesmo dia e horário agendado para {pet.name}
                  </S.Warning>
                )
              })}

              <S.Container hasAnotherPetScheduling={formList.length > 0}>
                {(formList.length > 0 && !changeStore && (scheduleBody.samePetDate === undefined || (formList.length > 0))) && (
                  <Ps.Position>
                    <Ps.LabelConfig>
                      {!isMobile() && error.unavailabilityPets?.map((pet, i) => {
                        return (
                          <S.Warning key={i}>
                            <img src={assetPrefix + '/static/icons/info-circle.svg'} />
                            Não temos profissionais disponíveis para o mesmo dia e horário agendado para {pet.name}
                          </S.Warning>
                        )
                      })}
                      <S.RadioGroupLocation fullWidth justifyContent='flex-start' gap='8px'>
                        {
                          formList.map(form =>
                            (
                              <Radio
                                name='pet-schedule'
                                label={form.scheduling.petName}
                                value={form.body.pet_id}
                                id={`pet-schedule-${form.body.pet_id}`}
                                defaultChecked={scheduleBody.samePetDate && selectedPetSchedule?.id === form.body.pet_id}
                                onChange={() => {
                                  handleSetChangeStore(false)
                                  handleSelectPartner(form.body.partner_id, { router, context }, form)
                                }}
                                key={form.body.pet_id}
                                active={!error.unavailabilityPets.some(pet => pet.id === form.body.pet_id)}
                              />
                            )
                          )
                        }
                        <Radio
                          name='pet-schedule'
                          label='Selecionar outro dia ou horário'
                          value=''
                          id='pet-schedule-new'
                          defaultChecked={scheduleBody.samePetDate === false}
                          onChange={() => {
                            handleSelectAnotherDayAndHour()
                          }}
                        />
                      </S.RadioGroupLocation>
                    </Ps.LabelConfig>
                  </Ps.Position>
                )}

                {(!formList.length > 0 || (changeStore && !selectedPetSchedule)) && (
                  <Ps.Position>
                    <Ps.LabelConfig>

                      <S.RadioGroupLocation fullWidth justifyContent='flex-start' gap='8px'>
                        <Radio name='partner-search' label='Localização' dataTest='radio-partner-location' value='location' id='radio-partner-location' onChange={(value) => handleOpenCustomAddress(value, { context })} defaultChecked={!isCustomAddress && partnersData && partnersData.length} chipStyle />
                        <Radio name='partner-search' label='CEP' dataTest='radio-partner-cep' value='cep' id='radio-partner-cep' onChange={(value) => handleOpenCustomAddress(value, { context })} defaultChecked={isCustomAddress && customAddressType === 'cep'} chipStyle />
                        <Radio name='partner-search' label='Loja' dataTest='radio-partner-store-name' value='storeName' id='radio-partner-store-name' onChange={(value) => handleOpenCustomAddress(value, { context })} defaultChecked={isCustomAddress && customAddressType === 'storeName'} chipStyle />
                        {userAddresses?.length > 0
                          ? userAddresses.map((item, index) => {
                            const { street, streetNumber, city } = item
                            return (
                              <Radio
                                key={index + street}
                                name='partner-search'
                                label={street}
                                dataTest='radio-partner-address'
                                value='address'
                                id={`radio-partner-address-${index}`}
                                onChange={(value) => {
                                  setIsEditingAddress(false)
                                  return handleOpenCustomAddress(value, { context }, index)
                                }}
                                defaultChecked={isCustomAddress && (address === `${street} ${streetNumber}, ${city}`)}
                                chipStyle
                              />
                            )
                          })
                          : <Radio name='partner-search' label='Endereço' dataTest='radio-partner-address' value='address' id='radio-partner-address' onChange={(value) => handleOpenCustomAddress(value, { context })} defaultChecked={isCustomAddress && customAddressType === 'address'} chipStyle />}
                      </S.RadioGroupLocation>

                      <Ps.RowCustomAddress>
                        {isCustomAddress && (
                          <S.CustomAddressInputs>
                            {
                              customAddressType === 'cep' ? (
                                <InputMask
                                  onChange={handleEditCep}
                                  type='text'
                                  name='cep'
                                  label='CEP'
                                  placeholder='Insira o CEP'
                                  margin='0'
                                  mask='#####-###'
                                  dataTest='input-address-cep'
                                  width='100%'
                                  onKeyPress={(event) => handlePressEnter(event)}
                                  value={cep}
                                  icon='search'
                                  onSearchButtonClick={() => handleLocationInputData({ context })}
                                  disabledButton={!cep && !address && !storeName}
                                  {...inputProps}
                                />
                              ) : (customAddressType === 'storeName' ? (
                                <Input
                                  onChange={handleEditStoreName}
                                  type='text'
                                  name='address'
                                  label='Loja'
                                  placeholder='Insira o nome da loja (Ex.: Augusta)'
                                  margin='0'
                                  dataTest='input-address-street'
                                  value={storeName}
                                  onKeyPress={(event) => handlePressEnter(event)}
                                  icon='search'
                                  onSearchButtonClick={() => handleLocationInputData({ context })}
                                  disabledButton={!cep && !address && !storeName}
                                  {...inputProps}
                                />
                              ) : (
                                <S.CustomAddressComplete>
                                  <Input
                                    onChange={(e) => {
                                      setIsEditingAddress(true)
                                      return handleEditLocation(e)
                                    }}
                                    type='text'
                                    name='address'
                                    label='Endereço'
                                    placeholder='Rua, Cidade ou Estado'
                                    margin='0'
                                    dataTest='input-address-street'
                                    value={address}
                                    onKeyPress={(event) => handlePressEnter(event)}
                                    onBlur={handleInputBlur}
                                    onFocus={handleInputFocus}
                                    icon='search'
                                    onSearchButtonClick={() => {
                                      setIsEditingAddress(false)
                                      return handleLocationInputData({ context })
                                    }}
                                    disabledButton={!cep && !address && !storeName}
                                    {...inputProps}
                                  />
                                </S.CustomAddressComplete>
                              ))
                            }
                          </S.CustomAddressInputs>
                        )}
                      </Ps.RowCustomAddress>
                    </Ps.LabelConfig>
                  </Ps.Position>
                )}

                {(selectedScheduleAvailable) && (
                  <>
                    {(formList.length > 0 && scheduleBody.samePetDate === false && !changeStore) && (
                      <Button
                        fontColor='var(--cobasi-blue-light-9)'
                        color='var(--the-white)'
                        label='Buscar outra loja'
                        onClick={() => refreshStore()}
                        margin='28px 0px 0px 0px'
                        radius='99px'
                        border='var(--cobasi-blue-light-9)'
                        dataTest='button-change-address'
                      />
                    )}

                    <S.StoreList>
                      {!!partnersData.length && partnersData.map(({
                        id,
                        name,
                        address,
                        distance,
                        phone,
                        photo,
                        ratingAverage,
                        isPetWorld
                      }) => {
                        const showPartner = !formList.length || (formList.length && scheduleBody.samePetDate !== undefined) || (changeStore && partnersData.length > 0)

                        return showPartner && (
                          <S.Card
                            key={id}
                            id={`partner-${id}`}
                            className={scheduleBody.partner_id === id ? 'selectedCard' : 'cardBorder'}
                            checked={scheduleBody.partner_id === id}
                            onClick={() => scheduleBody.partner_id !== id && handleSelectPartner(id, { router, context })}
                          >
                            <S.CardBody>
                              <S.CardContent>
                                <S.PartnerBody>
                                  <S.WrapperCompanyNameAndDistance>
                                    <S.LabelCompany>
                                      <span>{name}</span>
                                    </S.LabelCompany>
                                    {!!distance && <S.DistanceChip>{distance}</S.DistanceChip>}
                                  </S.WrapperCompanyNameAndDistance>

                                  <S.WrapperInfoRadio>
                                    <S.LabelInfo>
                                      <img src={MapMarquer} alt='icone-marcador' />
                                      <label>{address}</label>
                                    </S.LabelInfo>
                                    <div>
                                      <Radio dataTest={`radio-partner-${name.toLowerCase().replace(/\s/g, '-')}`} value={scheduleBody.partner_id} id={`radio-${id}`} defaultChecked={scheduleBody.partner_id === id} />
                                    </div>
                                  </S.WrapperInfoRadio>
                                </S.PartnerBody>
                              </S.CardContent>

                            </S.CardBody>
                            {isPetWorld && scheduleBody.partner_id === id && (
                              <Alert
                                type='info'
                                show
                                textContent='Se você tem Plano de Banho ativo, será cobrado apenas o serviço adicional. Confira com a recepção na realização do serviço.'
                              />
                            )}
                          </S.Card>
                        )
                      })}
                    </S.StoreList>
                  </>
                )}

                {(!!partnersData.length && customAddressType !== 'storeName' && (formList.length === 0 || (changeStore && !selectedPetSchedule))) && (
                  <S.Count>{partnersData.length} de {totalPartners} lojas</S.Count>
                )}

                {(totalPartners > partnersData.length && !!partnersData.length && (formList.length === 0 || (changeStore && !selectedPetSchedule))) && (
                  <S.WrapperButton>
                    <S.LoadMore type='button' onClick={() => loadMorePartnersData({ context })}>Carregar mais lojas</S.LoadMore>
                  </S.WrapperButton>
                )}
              </S.Container>
            </S.WrapperContainerAndTitle>
            {showSchedulingInfo() &&
              <SchedulingInfo />}
          </Gs.WrapperFormAndCard>
        </S.AlignWrappers>
      </FormSteps>
      <WarningModal
        visible={!!modal}
        cancelLabel={modal?.cancelLabel}
        confirmLabel={modal?.confirmLabel}
        type={modal?.type}
        title={modal?.title}
        subtitle={modal?.subtitle}
        onConfirm={modal?.onConfirm}
        onCancel={handleWarningModalClose}
        fullButton={modal?.fullButton}
        outlineCancelButton={modal?.outlineCancelButton}
        showClose={modal?.showClose}
        icon={modal?.icon ? modal?.icon : !modal?.professional ? `${assetPrefix}/static/icons/warning.svg` : ''}
        iconSize={modal?.iconSize}
        dataTest='modal-warning-scheduling'
      >
        {modal?.body}
      </WarningModal>

    </PageContainer>
  )
}

export default withRootContext(Location)
